// extracted by mini-css-extract-plugin
module.exports = {"colorBlack":"IconSingleEdition_colorBlack__AjB1Y","colorWhite":"IconSingleEdition_colorWhite__yWxff"};